import { ValuesResult } from "csi/store/Values";
import _ from "lodash";
import { SelectedFilterItems } from "./DelayFilteringService";

/** generate dropdown items for batch filter */
export function generateItemsForBatchFilters(selectedItems: SelectedFilterItems, items: ValuesResult[], put: (item: ValuesResult) => void): ValuesResult[] {
	const copiedItems = [...items];
	const itemsMap: _.Dictionary<ValuesResult> = _.keyBy(copiedItems, (x) => x._value);
	const indexSet = new Set(Object.keys(itemsMap));

	for (const entry of selectedItems) {
		const { _value } = entry;

		if (!indexSet.has(_value.toString())) {
			// if the selected value is not part of the store anymore, still need to be in store anyway so that CMS would work properly
			put(entry);
			copiedItems.unshift(entry);
		}
	}

	return copiedItems;
}